/* RESPONSIBLE TEAM: team-data-foundations */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';

export default class AuthenticationIndexRoute extends SettingsRoute {
  @service declare store;

  async model() {
    let tokens = await this.store.findAll('custom-authentication/token');
    return tokens.toArray();
  }
}
